// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Colors */
/****BRAND COLORS*****/
/****END BRAND COLORS*****/
/* Color Classes*/
/*#region*/
.blue.background {
  background: rgb(22, 109, 255) !important;
}
.blue.text {
  color: rgb(22, 109, 255) !important;
}

.green.background {
  background: rgb(124, 187, 46) !important;
}
.green.text {
  color: rgb(124, 187, 46) !important;
}

.gold.background {
  background: rgb(255, 189, 28) !important;
}
.gold.text {
  color: rgb(255, 189, 28) !important;
}

.orange.background {
  background: rgb(255, 132, 35) !important;
}
.orange.text {
  color: rgb(255, 132, 35) !important;
}

.red.background {
  background: rgb(255, 0, 0) !important;
}
.red.text {
  color: rgb(255, 0, 0) !important;
}

.pink.background {
  background: rgb(255, 47, 154) !important;
}
.pink.text {
  color: rgb(255, 47, 154) !important;
}

.purple.background {
  background: rgb(177, 0, 234) !important;
}
.purple.text {
  color: rgb(177, 0, 234) !important;
}

.cyan.background {
  background: rgb(48, 205, 155) !important;
}
.cyan.text {
  color: rgb(48, 205, 155) !important;
}

/*#endregion*/
/* Font */
/* Shadows */
/* Borders */
/* Transitions and Animations*/
/* Z Index */
/*Colors */
/****BRAND COLORS*****/
/****END BRAND COLORS*****/
/* Color Classes*/
/*#region*/
.blue.background {
  background: rgb(22, 109, 255) !important;
}
.blue.text {
  color: rgb(22, 109, 255) !important;
}

.green.background {
  background: rgb(124, 187, 46) !important;
}
.green.text {
  color: rgb(124, 187, 46) !important;
}

.gold.background {
  background: rgb(255, 189, 28) !important;
}
.gold.text {
  color: rgb(255, 189, 28) !important;
}

.orange.background {
  background: rgb(255, 132, 35) !important;
}
.orange.text {
  color: rgb(255, 132, 35) !important;
}

.red.background {
  background: rgb(255, 0, 0) !important;
}
.red.text {
  color: rgb(255, 0, 0) !important;
}

.pink.background {
  background: rgb(255, 47, 154) !important;
}
.pink.text {
  color: rgb(255, 47, 154) !important;
}

.purple.background {
  background: rgb(177, 0, 234) !important;
}
.purple.text {
  color: rgb(177, 0, 234) !important;
}

.cyan.background {
  background: rgb(48, 205, 155) !important;
}
.cyan.text {
  color: rgb(48, 205, 155) !important;
}

/*#endregion*/
/* Font */
/* Shadows */
/* Borders */
/* Transitions and Animations*/
/* Z Index */
@media screen and (max-width: 750px) {
  .main {
    padding: 5px !important;
  }
}
/*Wrapper contains the Nav and the Main Content*/
.wrapper {
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  height: 100%;
  min-height: 100vh;
  max-height: 100vh;
  display: flex;
}
.wrapper .page_transition_wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}
.wrapper .page_transition_wrapper .main {
  position: relative;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  padding: 10px;
  background: rgb(250, 250, 250);
}

/*Layout*/
.temp_flex {
  padding: 15px;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  background: #fff;
  box-shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;
}
.temp_flex > div:nth-child(1) {
  height: 100%;
  max-height: 100%;
  max-width: 300px;
}
.temp_flex > div:nth-child(2) {
  width: 100%;
}

.flex {
  display: flex;
}
.flex.justify_content_center {
  justify-content: center;
}
.flex.justify_content_space_between {
  justify-content: space-between;
}
.flex.align_items_center {
  align-items: center;
}

.flex_column {
  display: flex;
  height: 100%;
  flex-direction: column;
  max-height: 100%;
}
.flex_column .row_1 {
  flex: 1 1;
}
.flex_column .row_2 {
  flex: 1 1;
}
.flex_column .row_3 {
  flex: 1 1;
}

.flex_row {
  display: flex;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}
.flex_row .col_1 {
  flex: 1 1;
}
.flex_row .col_2 {
  flex: 2 1;
}
.flex_row .col_3 {
  flex: 3 1;
}

.padding {
  padding: 20px;
}
.padding.padding_10 {
  padding: 10px;
}

.page {
  height: 100%;
  overflow: hidden;
  max-height: 100%;
  max-width: 100%;
  position: relative;
}

.scrollX {
  overflow-x: scroll;
  width: 200vh !important;
  max-width: none;
}

.stretch_width {
  min-width: 100%;
}

.margin_center {
  margin: 0 auto;
}

.absolute_center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.max-w-100 {
  max-width: 100px;
}

/*Top Bar*/
.top_bar {
  display: flex;
  justify-content: space-between;
  margin: 10px;
}
.top_bar > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.top_bar .left {
  display: flex;
  justify-content: center;
  align-items: center;
}
.top_bar .right {
  display: flex;
  justify-content: center;
  align-items: center;
}

/*Rows */
.rows_wrapper {
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.row {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  margin: 6px 0px 6px 0px;
  border-radius: 0px;
  box-shadow: rgba(50, 50, 50, 0.1) 2px 3px 10px;
  padding: 15px;
  transition: all 200ms;
  color: rgba(0, 0, 0, 0.6);
}
.row:not(.header):hover {
  box-shadow: rgba(50, 50, 50, 0.15) 4px 5px 10px;
  color: rgb(0, 0, 0);
  z-index: 2;
}
.row.default {
  cursor: default;
}
.row.item > div {
  flex: 1 1;
  font-size: 14px;
}
.row.header {
  cursor: default;
  width: 100%;
  margin-bottom: 0px;
  height: 50px;
}
.row.header > div {
  flex: 1 1;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.6);
  transition: all 200ms;
  cursor: pointer;
}
.row.header > div svg {
  margin-left: 10px;
}
.row.header > div:hover {
  color: rgb(0, 0, 0);
}

/* Text */
.text_align_left {
  text-align: left !important;
}

.text_align_right {
  text-align: right !important;
}

.text_align_center {
  text-align: center !important;
}

/*Headers*/
.title {
  margin: 0px;
  max-width: 400px;
  text-align: center;
  transition: all 200ms;
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  font-size: 30px;
  cursor: default;
}
.title.form_title {
  margin: 20px auto;
  width: 100%;
  text-align: center;
}

/*Buttons and Links*/
.button_wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
}

.button {
  position: relative;
  display: block;
  text-align: center;
  text-transform: uppercase;
  padding: 8px 20px;
  white-space: nowrap;
  border-radius: 0px;
  cursor: pointer;
  margin: 10px;
  transition: all 200ms;
  font-size: 14px;
  outline: none;
}
.button:active {
  outline: none;
}
.button.primary {
  background: rgb(22, 109, 255);
  color: rgb(255, 255, 255);
}
.button.delete {
  background: rgb(224, 70, 70);
  color: rgb(255, 255, 255);
}
.button.outline {
  background: rgb(255, 255, 255);
  border: 1px solid rgb(22, 109, 255);
  color: rgb(22, 109, 255);
}
.button.outline:hover {
  color: rgb(255, 255, 255);
  background: rgb(22, 109, 255);
}
.button.checkout {
  background: rgb(255, 255, 255);
  border: 1px solid rgb(255, 132, 35);
  color: rgb(255, 132, 35);
}
.button.checkout:hover {
  color: rgb(255, 255, 255);
  background: rgb(255, 132, 35);
}
.button.suspend {
  background: rgb(255, 189, 28);
  color: rgb(255, 255, 255);
}
.button.unsuspend {
  background: rgb(124, 187, 46);
  color: rgb(255, 255, 255);
}
.button.upload {
  background: rgb(255, 189, 28);
  color: rgb(255, 255, 255);
  width: 180px;
}
.button.secondary {
  color: rgba(0, 0, 0, 0.6);
}
.button.slide_next {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.button.slide_next.left {
  right: 130px;
}
.button.slide_previous {
  position: absolute;
  bottom: 20px;
  left: 20px;
}
.button.back {
  background: rgb(255, 189, 28);
  color: rgb(255, 255, 255);
}
.button.back:hover svg {
  transition: all 200ms;
  transform: translateX(-5px);
}
.button.next svg {
  margin-left: 5px;
}
.button.next:hover svg {
  transition: all 200ms;
  transform: translateX(5px);
}
.button.form_button {
  margin: 30px 10px;
}
.button.row_button {
  background: rgb(48, 205, 155);
  color: rgb(255, 255, 255);
}
.button.center {
  margin: 0 auto;
  width: 100%;
  max-width: 250px;
}
.button.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.button.disabled:hover {
  filter: brightness(1);
}
.button svg {
  margin-right: 5px;
}

a {
  font-size: 14px;
}
a.link {
  color: rgb(22, 109, 255);
}
a.link:hover {
  text-decoration: underline !important;
}

/*Forms*/
form {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  padding: 20px 40px;
  min-width: 500px;
}
form .form_outline_error:not(.form_checkbox_wrapper) {
  border: 2px solid rgb(255, 0, 0) !important;
}
form .form_input_error {
  display: inline-block;
  margin-left: 5px;
  color: rgb(255, 0, 0);
  font-size: 12px;
}
form .form_group {
  display: flex;
  margin: 10px 0px;
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  /*HIDE ARROWS ON NUMBER INPUTS*
      /* Chrome, Safari, Edge, Opera */
  /* Firefox */
}
form .form_group > div {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  color: rgba(0, 0, 0, 0.6);
}
form .form_group > div:not(:nth-child(1)) {
  margin-left: 10px;
}
form .form_group .form_checkbox_wrapper {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
form .form_group .form_checkbox_wrapper > label {
  margin: 15px 0 10px 0;
  font-weight: 800;
}
form .form_group .form_checkbox_wrapper .form_input_error {
  font-weight: 500 !important;
}
form .form_group .form_checkbox_wrapper.form_outline_error .form_checkbox label {
  color: rgb(255, 0, 0);
}
form .form_group .form_checkbox_wrapper .form_checkbox_container {
  display: flex;
  justify-content: flex-start;
  cursor: default;
}
form .form_group .form_checkbox_wrapper .form_checkbox_container .form_checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
}
form .form_group .form_checkbox_wrapper .form_checkbox_container .form_checkbox:not(:nth-child(1)) {
  margin-left: 20px;
}
form .form_group .form_checkbox_wrapper .form_checkbox_container .form_checkbox input {
  border: none;
  cursor: pointer;
}
form .form_group .form_checkbox_wrapper .form_checkbox_container .form_checkbox label {
  cursor: pointer;
  margin-bottom: 0px;
  padding-right: 5px;
}
form .form_group label {
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 5px;
  font-size: 14px;
}
form .form_group label.disabled {
  opacity: 0.5;
}
form .form_group input[type=radio] {
  border: 1px solid rgba(30, 30, 30, 0.2) !important;
  min-width: 14px;
  min-height: 14px;
}
form .form_group input:not([type=checkbox]),
form .form_group select,
form .form_group textarea,
form .form_group .multi-select > .dropdown-container {
  width: 100%;
  border-radius: 5px;
  border: 2px solid transparent;
  padding: 10px;
  box-shadow: rgba(30, 30, 30, 0.1) 2px 2px 10px;
  outline: none;
  transition: all 200ms;
  color: rgba(0, 0, 0, 0.6);
}
form .form_group input:not([type=checkbox]):focus,
form .form_group select:focus,
form .form_group textarea:focus,
form .form_group .multi-select > .dropdown-container:focus {
  border: 2px solid rgba(0, 0, 0, 0.6);
}
form .form_group input:not([type=checkbox]):focus::placeholder,
form .form_group select:focus::placeholder,
form .form_group textarea:focus::placeholder,
form .form_group .multi-select > .dropdown-container:focus::placeholder {
  color: rgba(30, 30, 30, 0.5);
}
form .form_group input:not([type=checkbox])::placeholder,
form .form_group select::placeholder,
form .form_group textarea::placeholder,
form .form_group .multi-select > .dropdown-container::placeholder {
  color: rgba(30, 30, 30, 0.2);
  transition: all 200ms;
}
form .form_group input:not([type=checkbox]):hover,
form .form_group select:hover,
form .form_group textarea:hover,
form .form_group .multi-select > .dropdown-container:hover {
  box-shadow: rgba(30, 30, 30, 0.15) 4px 4px 15px;
}
form .form_group input:not([type=checkbox]):hover::placeholder,
form .form_group select:hover::placeholder,
form .form_group textarea:hover::placeholder,
form .form_group .multi-select > .dropdown-container:hover::placeholder {
  color: rgba(30, 30, 30, 0.5);
}
form .form_group input:not([type=checkbox]).disabled,
form .form_group select.disabled,
form .form_group textarea.disabled,
form .form_group .multi-select > .dropdown-container.disabled {
  opacity: 0.5;
}
form .form_group input:not([type=checkbox]).disabled:hover,
form .form_group select.disabled:hover,
form .form_group textarea.disabled:hover,
form .form_group .multi-select > .dropdown-container.disabled:hover {
  box-shadow: rgba(30, 30, 30, 0.1) 2px 2px 10px;
  border: 2px solid transparent;
  cursor: not-allowed;
}
form .form_group input:not([type=checkbox]).disabled:focus,
form .form_group select.disabled:focus,
form .form_group textarea.disabled:focus,
form .form_group .multi-select > .dropdown-container.disabled:focus {
  box-shadow: rgba(30, 30, 30, 0.1) 2px 2px 10px;
  border: 2px solid transparent;
}
form .form_group input:not([type=checkbox]).disabled::placeholder,
form .form_group select.disabled::placeholder,
form .form_group textarea.disabled::placeholder,
form .form_group .multi-select > .dropdown-container.disabled::placeholder {
  color: rgba(255, 255, 255, 0.5);
}
form .form_group .multi-select > .dropdown-container {
  padding: 0px;
}
form .form_group input::-webkit-outer-spin-button,
form .form_group input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
form .form_group input[type=number] {
  -moz-appearance: textfield;
}

.qty_wrapper .qty {
  width: 45px;
  padding: 5px;
  border: none;
  border: 1px solid rgba(30, 30, 30, 0.2);
  font-size: 16px;
}

/* Loader*/
.loader_fullscreen {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: rgba(20, 20, 20, 0.05);
  z-index: 403;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Leaflet */
.leaflet-draw.leaflet-control {
  display: none;
}
.leaflet-draw.leaflet-control:nth-child(2) {
  display: block !important;
}

.leaflet-control-layers-overlays > label:first-child {
  display: none;
}

/* Search Bar */
.search_bar {
  margin: 0 auto;
  margin-right: 10px;
  max-width: 100%;
}
.search_bar.margin_left {
  margin-left: 25px;
}
.search_bar input {
  width: 100%;
  border: 2px solid rgb(198, 198, 198);
  border-radius: 0px;
  padding: 5px;
  box-shadow: rgba(30, 30, 30, 0.1) 2px 2px 10px;
  outline: none;
  transition: all 200ms;
  color: rgba(0, 0, 0, 0.6);
}
.search_bar input:focus {
  border: 2px solid rgba(0, 0, 0, 0.6);
}
.search_bar input:focus::placeholder {
  color: rgba(30, 30, 30, 0.5);
}
.search_bar input::placeholder {
  color: rgba(30, 30, 30, 0.2);
  transition: all 200ms;
}
.search_bar input:hover {
  box-shadow: rgba(30, 30, 30, 0.15) 4px 4px 15px;
}
.search_bar input:hover::placeholder {
  color: rgba(30, 30, 30, 0.5);
}

/* CSS SPECIFIC STYLING */
/*Margin*/
/*#region*/
/*Margin Right*/
/*#region*/
.mr-5 {
  margin-right: 5px;
}

.mr-10 {
  margin-right: 5px;
}

.mr-15 {
  margin-right: 5px;
}

.mr-25 {
  margin-right: 5px;
}

.mr-50 {
  margin-right: 5px;
}

.mr-100 {
  margin-right: 5px;
}

.mr-125 {
  margin-right: 5px;
}

.mr-150 {
  margin-right: 5px;
}

.mr-175 {
  margin-right: 5px;
}

.mr-200 {
  margin-right: 5px;
}

/*#endregion*/
/*Margin Left*/
/*#region*/
/*Colors */
/****BRAND COLORS*****/
/****END BRAND COLORS*****/
/* Color Classes*/
/*#region*/
.blue.background {
  background: rgb(22, 109, 255) !important;
}
.blue.text {
  color: rgb(22, 109, 255) !important;
}

.green.background {
  background: rgb(124, 187, 46) !important;
}
.green.text {
  color: rgb(124, 187, 46) !important;
}

.gold.background {
  background: rgb(255, 189, 28) !important;
}
.gold.text {
  color: rgb(255, 189, 28) !important;
}

.orange.background {
  background: rgb(255, 132, 35) !important;
}
.orange.text {
  color: rgb(255, 132, 35) !important;
}

.red.background {
  background: rgb(255, 0, 0) !important;
}
.red.text {
  color: rgb(255, 0, 0) !important;
}

.pink.background {
  background: rgb(255, 47, 154) !important;
}
.pink.text {
  color: rgb(255, 47, 154) !important;
}

.purple.background {
  background: rgb(177, 0, 234) !important;
}
.purple.text {
  color: rgb(177, 0, 234) !important;
}

.cyan.background {
  background: rgb(48, 205, 155) !important;
}
.cyan.text {
  color: rgb(48, 205, 155) !important;
}

/*#endregion*/
/* Font */
/* Shadows */
/* Borders */
/* Transitions and Animations*/
/* Z Index */
.quotes_date_dropdown {
  width: 200px;
  background: #fff;
}
.quotes_date_dropdown div[class\$=-control] {
  border: none !important;
  box-shadow: rgba(50, 50, 50, 0.1) 2px 3px 10px;
  background: none;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0, 0, 0, 0));
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(209, 213, 219, var(--tw-ring-opacity));
}
.quotes_date_dropdown div:hover[class\$=-control] {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgba(96, 165, 250, var(--tw-ring-opacity));
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0, 0, 0, 0));
  transition-duration: 500ms;
}
.quotes_date_dropdown div {
  --tw-text-opacity: 1;
  color: rgba(55, 65, 81, var(--tw-text-opacity));
  font-size: 14px;
}
.quotes_date_dropdown .css-26l3qy-menu div:not(:hover) {
  background: none !important;
}
.quotes_date_dropdown .css-26l3qy-menu > div > div:hover {
  background: rgb(225, 235, 255);
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/styles/_main.scss","webpack://./src/styles/_mediaQueries.scss","webpack://./src/styles/_common.scss","webpack://./src/components/misc/select-dropdown/_selectDropdown.scss"],"names":[],"mappings":"AAGA,UAAA;AACA,sBAAA;AASA,0BAAA;AAoBA,iBAAA;AACA,UAAA;AAEI;EACI,wCAAA;AC9BR;ADgCI;EACI,mCAAA;AC9BR;;ADkCI;EACI,wCAAA;AC/BR;ADiCI;EACI,mCAAA;AC/BR;;ADmCI;EACI,wCAAA;AChCR;ADkCI;EACI,mCAAA;AChCR;;ADoCI;EACI,wCAAA;ACjCR;ADmCI;EACI,mCAAA;ACjCR;;ADqCI;EACI,qCAAA;AClCR;ADoCI;EACI,gCAAA;AClCR;;ADsCI;EACI,wCAAA;ACnCR;ADqCI;EACI,mCAAA;ACnCR;;ADuCI;EACI,uCAAA;ACpCR;ADsCI;EACI,kCAAA;ACpCR;;ADwCI;EACI,wCAAA;ACrCR;ADuCI;EACI,mCAAA;ACrCR;;ADwCA,aAAA;AAEA,SAAA;AAOA,YAAA;AAUA,YAAA;AAMA,8BAAA;AAIA,YAAA;AA7HA,UAAA;AACA,sBAAA;AASA,0BAAA;AAoBA,iBAAA;AACA,UAAA;AAEI;EACI,wCAAA;ACqCR;ADnCI;EACI,mCAAA;ACqCR;;ADjCI;EACI,wCAAA;ACoCR;ADlCI;EACI,mCAAA;ACoCR;;ADhCI;EACI,wCAAA;ACmCR;ADjCI;EACI,mCAAA;ACmCR;;AD/BI;EACI,wCAAA;ACkCR;ADhCI;EACI,mCAAA;ACkCR;;AD9BI;EACI,qCAAA;ACiCR;AD/BI;EACI,gCAAA;ACiCR;;AD7BI;EACI,wCAAA;ACgCR;AD9BI;EACI,mCAAA;ACgCR;;AD5BI;EACI,uCAAA;AC+BR;AD7BI;EACI,kCAAA;AC+BR;;AD3BI;EACI,wCAAA;AC8BR;AD5BI;EACI,mCAAA;AC8BR;;AD3BA,aAAA;AAEA,SAAA;AAOA,YAAA;AAUA,YAAA;AAMA,8BAAA;AAIA,YAAA;AEhIA;EACI;IACI,uBAAA;EDuIN;AACF;AEtIA,gDAAA;AACA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;AFwIJ;AEvII;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AFyIR;AExIQ;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;AF0IZ;;AErIA,SAAA;AACA;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,kDH2Ec;AC6DlB;AEtIQ;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;AFwIZ;AEtIQ;EACI,WAAA;AFwIZ;;AEpIA;EACI,aAAA;AFuIJ;AEtII;EACI,uBAAA;AFwIR;AEtII;EACI,8BAAA;AFwIR;AEtII;EACI,mBAAA;AFwIR;;AErIA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AFwIJ;AEtII;EACI,SAAA;AFwIR;AEtII;EACI,SAAA;AFwIR;AEtII;EACI,SAAA;AFwIR;;AErIA;EACI,aAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AFwIJ;AEvII;EACI,SAAA;AFyIR;AEvII;EACI,SAAA;AFyIR;AEvII;EACI,SAAA;AFyIR;;AEtIA;EACI,aAAA;AFyIJ;AExII;EACI,aAAA;AF0IR;;AEvIA;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AF0IJ;;AExIA;EACI,kBAAA;EACA,uBAAA;EACA,eAAA;AF2IJ;;AEzIA;EACI,eAAA;AF4IJ;;AE1IA;EACI,cAAA;AF6IJ;;AE3IA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AF8IJ;;AE5IA;EACI,gBAAA;AF+IJ;;AE5IA,UAAA;AACA;EACI,aAAA;EACA,8BAAA;EACA,YAAA;AF+IJ;AE7II;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AF+IR;AE7II;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AF+IR;AE7II;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AF+IR;;AE3IA,QAAA;AACA;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AF8IJ;;AE5IA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBHtIuB;EGuIvB,uBAAA;EACA,kBH9CY;EG+CZ,8CHxDS;EGyDT,aAAA;EACA,qBAAA;EACA,yBHrJmB;ACoSvB;AE7II;EACI,+CH7DW;EG8DX,mBH1JU;EG2JV,UAAA;AF+IR;AE5II;EACI,eAAA;AF8IR;AEzIQ;EACI,SAAA;EACA,eHjFS;AC4NrB;AEtII;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;AFwIR;AEvIQ;EACI,SAAA;EACA,yBAAA;EACA,yBHlLW;EGmLX,qBAAA;EACA,eAAA;AFyIZ;AEvIY;EAEI,iBAAA;AFwIhB;AErIY;EACI,mBH7LE;ACoUlB;;AEhIA,SAAA;AACA;EACI,2BAAA;AFmIJ;;AEjIA;EACI,4BAAA;AFoIJ;;AElIA;EACI,6BAAA;AFqIJ;;AElIA,UAAA;AACA;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBHpNmB;EGqNnB,yBAAA;EACA,eAAA;EACA,eAAA;AFqIJ;AEnII;EACI,iBAAA;EACA,WAAA;EACA,kBAAA;AFqIR;;AEjIA,oBAAA;AACA;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;AFoIJ;;AElIA;EACI,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBH1ImB;EG2InB,eAAA;EACA,YAAA;EACA,qBAAA;EACA,eHhKe;EGiKf,aAAA;AFqIJ;AEnII;EACI,aAAA;AFqIR;AElII;EACI,6BH9PQ;EG+PR,yBH1PW;AC8XnB;AElII;EACI,4BHjQM;EGkQN,yBH9PW;ACkYnB;AElII;EACI,8BHjQW;EGkQX,mCAAA;EACA,wBHxQQ;AC4YhB;AElIQ;EACI,yBHtQO;EGuQP,6BH5QI;ACgZhB;AEjII;EACI,8BH3QW;EG4QX,mCAAA;EACA,wBH1RC;AC6ZT;AEjIQ;EACI,yBHhRO;EGiRP,6BH9RH;ACiaT;AEhII;EACI,6BHnSD;EGoSC,yBHtRW;ACwZnB;AEhII;EACI,6BHxSA;EGySA,yBH1RW;AC4ZnB;AEhII;EACI,6BH3SD;EG4SC,yBH9RW;EG+RX,YAAA;AFkIR;AE9HI;EACI,yBHrSe;ACqavB;AE9HI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;AFgIR;AE9HQ;EACI,YAAA;AFgIZ;AE3HI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;AF6HR;AE3HI;EACI,6BHrUD;EGsUC,yBHxTW;ACqbnB;AE3HY;EACI,qBAAA;EACA,2BAAA;AF6HhB;AExHQ;EACI,gBAAA;AF0HZ;AEvHY;EACI,qBAAA;EACA,0BAAA;AFyHhB;AErHI;EAEI,iBAAA;AFsHR;AEpHI;EACI,6BHzVD;EG0VC,yBHjVW;ACucnB;AEpHI;EACI,cAAA;EACA,WAAA;EACA,gBAAA;AFsHR;AEpHI;EACI,mBAAA;EACA,YAAA;AFsHR;AErHQ;EACI,qBAAA;AFuHZ;AEpHI;EAEI,iBAAA;AFqHR;;AElHA;EACI,eHlRiB;ACuYrB;AEpHI;EACI,wBHvXD;AC6eP;AErHQ;EACI,qCAAA;AFuHZ;;AElHA,QAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AFqHJ;AEnHI;EACI,2CAAA;AFqHR;AElHI;EACI,qBAAA;EACA,gBAAA;EACA,qBH1YF;EG2YE,eH1SU;AC8ZlB;AEjHI;EACI,aAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EA8HA;sCAAA;EAOA,YAAA;AFfR;AEpHQ;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBH9YW;ACogBvB;AEpHY;EACI,iBAAA;AFsHhB;AElHQ;EACI,aAAA;EACA,2BAAA;EACA,sBAAA;AFoHZ;AElHY;EACI,qBAAA;EACA,gBAAA;AFoHhB;AEjHY;EACI,2BAAA;AFmHhB;AE/GgB;EACI,qBHhbd;ACiiBN;AE7GY;EACI,aAAA;EACA,2BAAA;EACA,eAAA;AF+GhB;AE9GgB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AFgHpB;AE9GoB;EACI,iBAAA;AFgHxB;AE7GoB;EACI,YAAA;EACA,eAAA;AF+GxB;AE7GoB;EACI,eAAA;EACA,kBAAA;EACA,kBAAA;AF+GxB;AEzGQ;EACI,yBHpcW;EGqcX,kBAAA;EACA,eHlXS;AC6drB;AEzGY;EACI,YAAA;AF2GhB;AEvGQ;EACI,kDAAA;EACA,eH3XS;EG4XT,gBH5XS;ACqerB;AEtGQ;;;;EAII,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,8CH7XQ;EG8XR,aAAA;EACA,qBAAA;EACA,yBH9dW;ACskBvB;AEtGY;;;;EACI,oCAAA;AF2GhB;AEzGgB;;;;EACI,4BH9dM;AC4kB1B;AE3GY;;;;EACI,4BHneI;EGoeJ,qBAAA;AFgHhB;AE9GY;;;;EACI,+CH5YU;AC+f1B;AElHgB;;;;EACI,4BHxeM;AC+lB1B;AEpHY;;;;EACI,YAAA;AFyHhB;AExHgB;;;;EACI,8CHtZA;EGuZA,6BAAA;EACA,mBAAA;AF6HpB;AE3HgB;;;;EACI,8CH3ZA;EG4ZA,6BAAA;AFgIpB;AE9HgB;;;;EACI,+BH3fI;AC8nBxB;AE9HQ;EACI,YAAA;AFgIZ;AE3HQ;;EAEI,wBAAA;EACA,SAAA;AF6HZ;AE1HQ;EACI,0BAAA;AF4HZ;;AEvHI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,uCAAA;EACA,eAAA;AF0HR;;AEtHA,UAAA;AACA;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,YHxbO;EGybP,aAAA;EACA,uBAAA;EACA,mBAAA;AFyHJ;;AEtHA,YAAA;AAEI;EACI,aAAA;AFwHR;AEtHI;EACI,yBAAA;AFwHR;;AEpHI;EACI,aAAA;AFuHR;;AEnHA,eAAA;AACA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;AFsHJ;AErHI;EACI,iBAAA;AFuHR;AErHI;EACI,WAAA;EACA,oCAAA;EACA,kBHleQ;EGmeR,YAAA;EACA,8CHzeY;EG0eZ,aAAA;EACA,qBAAA;EACA,yBH1kBe;ACisBvB;AErHQ;EACI,oCAAA;AFuHZ;AEtHY;EACI,4BHzkBU;ACisB1B;AErHQ;EACI,4BH9kBQ;EG+kBR,qBAAA;AFuHZ;AErHQ;EACI,+CHvfc;AC8mB1B;AEtHY;EACI,4BHnlBU;AC2sB1B;;AEjHA,yBAAA;AAEA,SAAA;AACA,UAAA;AAEA,eAAA;AACA,UAAA;AACA;EACI,iBAAA;AFkHJ;;AEhHA;EACI,iBAAA;AFmHJ;;AEjHA;EACI,iBAAA;AFoHJ;;AElHA;EACI,iBAAA;AFqHJ;;AEnHA;EACI,iBAAA;AFsHJ;;AEpHA;EACI,iBAAA;AFuHJ;;AErHA;EACI,iBAAA;AFwHJ;;AEtHA;EACI,iBAAA;AFyHJ;;AEvHA;EACI,iBAAA;AF0HJ;;AExHA;EACI,iBAAA;AF2HJ;;AEzHA,aAAA;AAEA,cAAA;AACA,UAAA;AHzpBA,UAAA;AACA,sBAAA;AASA,0BAAA;AAoBA,iBAAA;AACA,UAAA;AAEI;EACI,wCAAA;ACyvBR;ADvvBI;EACI,mCAAA;ACyvBR;;ADrvBI;EACI,wCAAA;ACwvBR;ADtvBI;EACI,mCAAA;ACwvBR;;ADpvBI;EACI,wCAAA;ACuvBR;ADrvBI;EACI,mCAAA;ACuvBR;;ADnvBI;EACI,wCAAA;ACsvBR;ADpvBI;EACI,mCAAA;ACsvBR;;ADlvBI;EACI,qCAAA;ACqvBR;ADnvBI;EACI,gCAAA;ACqvBR;;ADjvBI;EACI,wCAAA;ACovBR;ADlvBI;EACI,mCAAA;ACovBR;;ADhvBI;EACI,uCAAA;ACmvBR;ADjvBI;EACI,kCAAA;ACmvBR;;AD/uBI;EACI,wCAAA;ACkvBR;ADhvBI;EACI,mCAAA;ACkvBR;;AD/uBA,aAAA;AAEA,SAAA;AAOA,YAAA;AAUA,YAAA;AAMA,8BAAA;AAIA,YAAA;AI9HA;EACI,YAAA;EACA,gBAAA;AHy1BJ;AGv1BI;EACI,uBAAA;EACA,8CJsGK;EIrGL,gBAAA;EAEA,2GAAA;EACA,yGAAA;EACA,uGAAA;EAEA,oBAAA;EACA,4DAAA;AHu1BR;AGp1BI;EACI,oBAAA;EACA,2DAAA;EACA,2GAAA;EACA,yGAAA;EACA,uGAAA;EACA,0BAAA;AHs1BR;AGn1BI;EACI,oBAAA;EACA,+CAAA;EACA,eAAA;AHq1BR;AGl1BI;EACI,2BAAA;AHo1BR;AGj1BI;EACI,8BAAA;AHm1BR","sourcesContent":["// @import './variables';\r\n// @import './common';\r\n\r\n/*Colors */\r\n/****BRAND COLORS*****/\r\n$blue: rgb(22,109,255);\r\n$green: rgb(124,187,46);\r\n$gold: rgb(255,189,28);\r\n$orange: rgb(255,132,35);;\r\n$red: rgb(255,0,0);\r\n$pink: rgb(255,47,154);\r\n$purple: rgb(177,0,234);\r\n$cyan: rgb(48,205,155);\r\n/****END BRAND COLORS*****/\r\n$color_gray: rgb(198, 198, 198);\r\n$color_undefined: rgb(198, 198, 198);\r\n$color_primary: rgb(22,109,255);\r\n$color_error: rgb(224, 70, 70);\r\n$color_disabled: rgba(30,30,30,.3);\r\n$text_color_dark: rgba(0,0,0,1);\r\n$text_color_dark_soft: rgba(0,0,0,.6); \r\n$text_color_light: rgba(255,255,255,1);\r\n$text_color_light_soft: rgba(255,255,255,.5);\r\n$border_color_primary: rgba(30,30,30,.2);\r\n$button_border_color_primary: rgba(31, 74, 193, 1);\r\n$placeholder_color: rgba(30,30,30,.2);\r\n$placeholder_color_hover: rgba(30,30,30,.5);\r\n$navigation_button_color_hover: rgba(194, 205, 238, 0.2);\r\n\r\n$background_color_primary: #fff;\r\n$background_color_secondary: rgb(253, 253, 253);\r\n\r\n\r\n/* Color Classes*/\r\n/*#region*/\r\n.blue {\r\n    &.background {\r\n        background: $blue !important;\r\n    }\r\n    &.text {\r\n        color: $blue !important;\r\n    }\r\n}\r\n.green {\r\n    &.background {\r\n        background: $green !important;\r\n    }\r\n    &.text {\r\n        color: $green !important;\r\n    }\r\n}\r\n.gold {\r\n    &.background {\r\n        background: $gold !important;\r\n    }\r\n    &.text {\r\n        color: $gold !important;\r\n    }\r\n}\r\n.orange {\r\n    &.background {\r\n        background: $orange !important; \r\n    }\r\n    &.text {\r\n        color: $orange !important;\r\n    }\r\n}\r\n.red {\r\n    &.background {\r\n        background: $red !important;\r\n    }\r\n    &.text {\r\n        color: $red !important;\r\n    }\r\n}\r\n.pink {\r\n    &.background {\r\n        background: $pink !important;\r\n    }\r\n    &.text {\r\n        color: $pink !important;\r\n    }\r\n}\r\n.purple {\r\n    &.background {\r\n        background: $purple !important;\r\n    }\r\n    &.text {\r\n        color: $purple !important;\r\n    }\r\n}\r\n.cyan {\r\n    &.background {\r\n        background: $cyan !important;\r\n    }\r\n    &.text {\r\n        color: $cyan !important;\r\n    }\r\n}\r\n/*#endregion*/\r\n\r\n/* Font */\r\n$font_size_button: 14px;\r\n$font_size_navigation: 16px;\r\n$font_size_standard: 14px;\r\n$font_size_subtitle: 24px;\r\n$font_size_small: 12px;\r\n\r\n/* Shadows */\r\n$soft_shadow: rgba(0, 0, 0, 0.2) 0px 24px 38px 3px;\r\n$row_shadow: rgba(50,50,50,.1) 2px 3px 10px;\r\n$row_shadow_hover: rgba(50,50,50,.15) 4px 5px 10px;\r\n$side_nav_shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;\r\n//$form_input_shadow: rgba(0, 0, 0, 0.1) 0px 10px 10px 0px; //original\r\n$form_input_shadow: rgba(30,30, 30, .1) 2px 2px 10px ;\r\n//$form_input_shadow_hover: rgba(0, 0, 0, 0.11) 2px 14px 10px 0px; //original\r\n$form_input_shadow_hover: rgba(30,30, 30, .15) 4px 4px 15px ;\r\n\r\n/* Borders */\r\n$border_radius: 0px;\r\n$border_button_radius: 0px;\r\n$border_active_width: 0px;\r\n$border_round: 20px;\r\n\r\n/* Transitions and Animations*/\r\n$transition_speed: 200ms;\r\n$animation_speed: 400ms; //currently used for fading in modal\r\n\r\n/* Z Index */\r\n$z_loader: 403;\r\n$z_modal_foreground: 402;\r\n$z_modal_background: 401;\r\n$z_sidecart: 97;\r\n$z_sidecart_background: 96;\r\n$z_select_dropdown: 94;\r\n$z_navbar: 95;","/*Colors */\n/****BRAND COLORS*****/\n/****END BRAND COLORS*****/\n/* Color Classes*/\n/*#region*/\n.blue.background {\n  background: rgb(22, 109, 255) !important;\n}\n.blue.text {\n  color: rgb(22, 109, 255) !important;\n}\n\n.green.background {\n  background: rgb(124, 187, 46) !important;\n}\n.green.text {\n  color: rgb(124, 187, 46) !important;\n}\n\n.gold.background {\n  background: rgb(255, 189, 28) !important;\n}\n.gold.text {\n  color: rgb(255, 189, 28) !important;\n}\n\n.orange.background {\n  background: rgb(255, 132, 35) !important;\n}\n.orange.text {\n  color: rgb(255, 132, 35) !important;\n}\n\n.red.background {\n  background: rgb(255, 0, 0) !important;\n}\n.red.text {\n  color: rgb(255, 0, 0) !important;\n}\n\n.pink.background {\n  background: rgb(255, 47, 154) !important;\n}\n.pink.text {\n  color: rgb(255, 47, 154) !important;\n}\n\n.purple.background {\n  background: rgb(177, 0, 234) !important;\n}\n.purple.text {\n  color: rgb(177, 0, 234) !important;\n}\n\n.cyan.background {\n  background: rgb(48, 205, 155) !important;\n}\n.cyan.text {\n  color: rgb(48, 205, 155) !important;\n}\n\n/*#endregion*/\n/* Font */\n/* Shadows */\n/* Borders */\n/* Transitions and Animations*/\n/* Z Index */\n/*Colors */\n/****BRAND COLORS*****/\n/****END BRAND COLORS*****/\n/* Color Classes*/\n/*#region*/\n.blue.background {\n  background: rgb(22, 109, 255) !important;\n}\n.blue.text {\n  color: rgb(22, 109, 255) !important;\n}\n\n.green.background {\n  background: rgb(124, 187, 46) !important;\n}\n.green.text {\n  color: rgb(124, 187, 46) !important;\n}\n\n.gold.background {\n  background: rgb(255, 189, 28) !important;\n}\n.gold.text {\n  color: rgb(255, 189, 28) !important;\n}\n\n.orange.background {\n  background: rgb(255, 132, 35) !important;\n}\n.orange.text {\n  color: rgb(255, 132, 35) !important;\n}\n\n.red.background {\n  background: rgb(255, 0, 0) !important;\n}\n.red.text {\n  color: rgb(255, 0, 0) !important;\n}\n\n.pink.background {\n  background: rgb(255, 47, 154) !important;\n}\n.pink.text {\n  color: rgb(255, 47, 154) !important;\n}\n\n.purple.background {\n  background: rgb(177, 0, 234) !important;\n}\n.purple.text {\n  color: rgb(177, 0, 234) !important;\n}\n\n.cyan.background {\n  background: rgb(48, 205, 155) !important;\n}\n.cyan.text {\n  color: rgb(48, 205, 155) !important;\n}\n\n/*#endregion*/\n/* Font */\n/* Shadows */\n/* Borders */\n/* Transitions and Animations*/\n/* Z Index */\n@media screen and (max-width: 750px) {\n  .main {\n    padding: 5px !important;\n  }\n}\n/*Wrapper contains the Nav and the Main Content*/\n.wrapper {\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  height: 100%;\n  min-height: 100vh;\n  max-height: 100vh;\n  display: flex;\n}\n.wrapper .page_transition_wrapper {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.wrapper .page_transition_wrapper .main {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n  padding: 10px;\n  background: rgb(250, 250, 250);\n}\n\n/*Layout*/\n.temp_flex {\n  padding: 15px;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n  display: flex;\n  background: #fff;\n  box-shadow: rgba(30, 30, 30, 0.1) 5px 0px 15px 3px;\n}\n.temp_flex > div:nth-child(1) {\n  height: 100%;\n  max-height: 100%;\n  max-width: 300px;\n}\n.temp_flex > div:nth-child(2) {\n  width: 100%;\n}\n\n.flex {\n  display: flex;\n}\n.flex.justify_content_center {\n  justify-content: center;\n}\n.flex.justify_content_space_between {\n  justify-content: space-between;\n}\n.flex.align_items_center {\n  align-items: center;\n}\n\n.flex_column {\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  max-height: 100%;\n}\n.flex_column .row_1 {\n  flex: 1;\n}\n.flex_column .row_2 {\n  flex: 1;\n}\n.flex_column .row_3 {\n  flex: 1;\n}\n\n.flex_row {\n  display: flex;\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n}\n.flex_row .col_1 {\n  flex: 1;\n}\n.flex_row .col_2 {\n  flex: 2;\n}\n.flex_row .col_3 {\n  flex: 3;\n}\n\n.padding {\n  padding: 20px;\n}\n.padding.padding_10 {\n  padding: 10px;\n}\n\n.page {\n  height: 100%;\n  overflow: hidden;\n  max-height: 100%;\n  max-width: 100%;\n  position: relative;\n}\n\n.scrollX {\n  overflow-x: scroll;\n  width: 200vh !important;\n  max-width: none;\n}\n\n.stretch_width {\n  min-width: 100%;\n}\n\n.margin_center {\n  margin: 0 auto;\n}\n\n.absolute_center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.max-w-100 {\n  max-width: 100px;\n}\n\n/*Top Bar*/\n.top_bar {\n  display: flex;\n  justify-content: space-between;\n  margin: 10px;\n}\n.top_bar > div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.top_bar .left {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.top_bar .right {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/*Rows */\n.rows_wrapper {\n  height: 100%;\n  max-height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.row {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  background: #fff;\n  margin: 6px 0px 6px 0px;\n  border-radius: 0px;\n  box-shadow: rgba(50, 50, 50, 0.1) 2px 3px 10px;\n  padding: 15px;\n  transition: all 200ms;\n  color: rgba(0, 0, 0, 0.6);\n}\n.row:not(.header):hover {\n  box-shadow: rgba(50, 50, 50, 0.15) 4px 5px 10px;\n  color: rgb(0, 0, 0);\n  z-index: 2;\n}\n.row.default {\n  cursor: default;\n}\n.row.item > div {\n  flex: 1;\n  font-size: 14px;\n}\n.row.header {\n  cursor: default;\n  width: 100%;\n  margin-bottom: 0px;\n  height: 50px;\n}\n.row.header > div {\n  flex: 1;\n  text-transform: uppercase;\n  color: rgba(0, 0, 0, 0.6);\n  transition: all 200ms;\n  cursor: pointer;\n}\n.row.header > div svg {\n  margin-left: 10px;\n}\n.row.header > div:hover {\n  color: rgb(0, 0, 0);\n}\n\n/* Text */\n.text_align_left {\n  text-align: left !important;\n}\n\n.text_align_right {\n  text-align: right !important;\n}\n\n.text_align_center {\n  text-align: center !important;\n}\n\n/*Headers*/\n.title {\n  margin: 0px;\n  max-width: 400px;\n  text-align: center;\n  transition: all 200ms;\n  color: rgba(0, 0, 0, 0.6);\n  text-transform: uppercase;\n  font-size: 30px;\n  cursor: default;\n}\n.title.form_title {\n  margin: 20px auto;\n  width: 100%;\n  text-align: center;\n}\n\n/*Buttons and Links*/\n.button_wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 100%;\n}\n\n.button {\n  position: relative;\n  display: block;\n  text-align: center;\n  text-transform: uppercase;\n  padding: 8px 20px;\n  white-space: nowrap;\n  border-radius: 0px;\n  cursor: pointer;\n  margin: 10px;\n  transition: all 200ms;\n  font-size: 14px;\n  outline: none;\n}\n.button:active {\n  outline: none;\n}\n.button.primary {\n  background: rgb(22, 109, 255);\n  color: rgb(255, 255, 255);\n}\n.button.delete {\n  background: rgb(224, 70, 70);\n  color: rgb(255, 255, 255);\n}\n.button.outline {\n  background: rgb(255, 255, 255);\n  border: 1px solid rgb(22, 109, 255);\n  color: rgb(22, 109, 255);\n}\n.button.outline:hover {\n  color: rgb(255, 255, 255);\n  background: rgb(22, 109, 255);\n}\n.button.checkout {\n  background: rgb(255, 255, 255);\n  border: 1px solid rgb(255, 132, 35);\n  color: rgb(255, 132, 35);\n}\n.button.checkout:hover {\n  color: rgb(255, 255, 255);\n  background: rgb(255, 132, 35);\n}\n.button.suspend {\n  background: rgb(255, 189, 28);\n  color: rgb(255, 255, 255);\n}\n.button.unsuspend {\n  background: rgb(124, 187, 46);\n  color: rgb(255, 255, 255);\n}\n.button.upload {\n  background: rgb(255, 189, 28);\n  color: rgb(255, 255, 255);\n  width: 180px;\n}\n.button.secondary {\n  color: rgba(0, 0, 0, 0.6);\n}\n.button.slide_next {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n}\n.button.slide_next.left {\n  right: 130px;\n}\n.button.slide_previous {\n  position: absolute;\n  bottom: 20px;\n  left: 20px;\n}\n.button.back {\n  background: rgb(255, 189, 28);\n  color: rgb(255, 255, 255);\n}\n.button.back:hover svg {\n  transition: all 200ms;\n  transform: translateX(-5px);\n}\n.button.next svg {\n  margin-left: 5px;\n}\n.button.next:hover svg {\n  transition: all 200ms;\n  transform: translateX(5px);\n}\n.button.form_button {\n  margin: 30px 10px;\n}\n.button.row_button {\n  background: rgb(48, 205, 155);\n  color: rgb(255, 255, 255);\n}\n.button.center {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 250px;\n}\n.button.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n.button.disabled:hover {\n  filter: brightness(1);\n}\n.button svg {\n  margin-right: 5px;\n}\n\na {\n  font-size: 14px;\n}\na.link {\n  color: rgb(22, 109, 255);\n}\na.link:hover {\n  text-decoration: underline !important;\n}\n\n/*Forms*/\nform {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  overflow-y: auto;\n  padding: 20px 40px;\n  min-width: 500px;\n}\nform .form_outline_error:not(.form_checkbox_wrapper) {\n  border: 2px solid rgb(255, 0, 0) !important;\n}\nform .form_input_error {\n  display: inline-block;\n  margin-left: 5px;\n  color: rgb(255, 0, 0);\n  font-size: 12px;\n}\nform .form_group {\n  display: flex;\n  margin: 10px 0px;\n  cursor: pointer;\n  width: 100%;\n  max-width: 100%;\n  /*HIDE ARROWS ON NUMBER INPUTS*\n      /* Chrome, Safari, Edge, Opera */\n  /* Firefox */\n}\nform .form_group > div {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  color: rgba(0, 0, 0, 0.6);\n}\nform .form_group > div:not(:nth-child(1)) {\n  margin-left: 10px;\n}\nform .form_group .form_checkbox_wrapper {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n}\nform .form_group .form_checkbox_wrapper > label {\n  margin: 15px 0 10px 0;\n  font-weight: 800;\n}\nform .form_group .form_checkbox_wrapper .form_input_error {\n  font-weight: 500 !important;\n}\nform .form_group .form_checkbox_wrapper.form_outline_error .form_checkbox label {\n  color: rgb(255, 0, 0);\n}\nform .form_group .form_checkbox_wrapper .form_checkbox_container {\n  display: flex;\n  justify-content: flex-start;\n  cursor: default;\n}\nform .form_group .form_checkbox_wrapper .form_checkbox_container .form_checkbox {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\nform .form_group .form_checkbox_wrapper .form_checkbox_container .form_checkbox:not(:nth-child(1)) {\n  margin-left: 20px;\n}\nform .form_group .form_checkbox_wrapper .form_checkbox_container .form_checkbox input {\n  border: none;\n  cursor: pointer;\n}\nform .form_group .form_checkbox_wrapper .form_checkbox_container .form_checkbox label {\n  cursor: pointer;\n  margin-bottom: 0px;\n  padding-right: 5px;\n}\nform .form_group label {\n  color: rgba(0, 0, 0, 0.6);\n  margin-bottom: 5px;\n  font-size: 14px;\n}\nform .form_group label.disabled {\n  opacity: 0.5;\n}\nform .form_group input[type=radio] {\n  border: 1px solid rgba(30, 30, 30, 0.2) !important;\n  min-width: 14px;\n  min-height: 14px;\n}\nform .form_group input:not([type=checkbox]),\nform .form_group select,\nform .form_group textarea,\nform .form_group .multi-select > .dropdown-container {\n  width: 100%;\n  border-radius: 5px;\n  border: 2px solid transparent;\n  padding: 10px;\n  box-shadow: rgba(30, 30, 30, 0.1) 2px 2px 10px;\n  outline: none;\n  transition: all 200ms;\n  color: rgba(0, 0, 0, 0.6);\n}\nform .form_group input:not([type=checkbox]):focus,\nform .form_group select:focus,\nform .form_group textarea:focus,\nform .form_group .multi-select > .dropdown-container:focus {\n  border: 2px solid rgba(0, 0, 0, 0.6);\n}\nform .form_group input:not([type=checkbox]):focus::placeholder,\nform .form_group select:focus::placeholder,\nform .form_group textarea:focus::placeholder,\nform .form_group .multi-select > .dropdown-container:focus::placeholder {\n  color: rgba(30, 30, 30, 0.5);\n}\nform .form_group input:not([type=checkbox])::placeholder,\nform .form_group select::placeholder,\nform .form_group textarea::placeholder,\nform .form_group .multi-select > .dropdown-container::placeholder {\n  color: rgba(30, 30, 30, 0.2);\n  transition: all 200ms;\n}\nform .form_group input:not([type=checkbox]):hover,\nform .form_group select:hover,\nform .form_group textarea:hover,\nform .form_group .multi-select > .dropdown-container:hover {\n  box-shadow: rgba(30, 30, 30, 0.15) 4px 4px 15px;\n}\nform .form_group input:not([type=checkbox]):hover::placeholder,\nform .form_group select:hover::placeholder,\nform .form_group textarea:hover::placeholder,\nform .form_group .multi-select > .dropdown-container:hover::placeholder {\n  color: rgba(30, 30, 30, 0.5);\n}\nform .form_group input:not([type=checkbox]).disabled,\nform .form_group select.disabled,\nform .form_group textarea.disabled,\nform .form_group .multi-select > .dropdown-container.disabled {\n  opacity: 0.5;\n}\nform .form_group input:not([type=checkbox]).disabled:hover,\nform .form_group select.disabled:hover,\nform .form_group textarea.disabled:hover,\nform .form_group .multi-select > .dropdown-container.disabled:hover {\n  box-shadow: rgba(30, 30, 30, 0.1) 2px 2px 10px;\n  border: 2px solid transparent;\n  cursor: not-allowed;\n}\nform .form_group input:not([type=checkbox]).disabled:focus,\nform .form_group select.disabled:focus,\nform .form_group textarea.disabled:focus,\nform .form_group .multi-select > .dropdown-container.disabled:focus {\n  box-shadow: rgba(30, 30, 30, 0.1) 2px 2px 10px;\n  border: 2px solid transparent;\n}\nform .form_group input:not([type=checkbox]).disabled::placeholder,\nform .form_group select.disabled::placeholder,\nform .form_group textarea.disabled::placeholder,\nform .form_group .multi-select > .dropdown-container.disabled::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\nform .form_group .multi-select > .dropdown-container {\n  padding: 0px;\n}\nform .form_group input::-webkit-outer-spin-button,\nform .form_group input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\nform .form_group input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.qty_wrapper .qty {\n  width: 45px;\n  padding: 5px;\n  border: none;\n  border: 1px solid rgba(30, 30, 30, 0.2);\n  font-size: 16px;\n}\n\n/* Loader*/\n.loader_fullscreen {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background: rgba(20, 20, 20, 0.05);\n  z-index: 403;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Leaflet */\n.leaflet-draw.leaflet-control {\n  display: none;\n}\n.leaflet-draw.leaflet-control:nth-child(2) {\n  display: block !important;\n}\n\n.leaflet-control-layers-overlays > label:first-child {\n  display: none;\n}\n\n/* Search Bar */\n.search_bar {\n  margin: 0 auto;\n  margin-right: 10px;\n  max-width: 100%;\n}\n.search_bar.margin_left {\n  margin-left: 25px;\n}\n.search_bar input {\n  width: 100%;\n  border: 2px solid rgb(198, 198, 198);\n  border-radius: 0px;\n  padding: 5px;\n  box-shadow: rgba(30, 30, 30, 0.1) 2px 2px 10px;\n  outline: none;\n  transition: all 200ms;\n  color: rgba(0, 0, 0, 0.6);\n}\n.search_bar input:focus {\n  border: 2px solid rgba(0, 0, 0, 0.6);\n}\n.search_bar input:focus::placeholder {\n  color: rgba(30, 30, 30, 0.5);\n}\n.search_bar input::placeholder {\n  color: rgba(30, 30, 30, 0.2);\n  transition: all 200ms;\n}\n.search_bar input:hover {\n  box-shadow: rgba(30, 30, 30, 0.15) 4px 4px 15px;\n}\n.search_bar input:hover::placeholder {\n  color: rgba(30, 30, 30, 0.5);\n}\n\n/* CSS SPECIFIC STYLING */\n/*Margin*/\n/*#region*/\n/*Margin Right*/\n/*#region*/\n.mr-5 {\n  margin-right: 5px;\n}\n\n.mr-10 {\n  margin-right: 5px;\n}\n\n.mr-15 {\n  margin-right: 5px;\n}\n\n.mr-25 {\n  margin-right: 5px;\n}\n\n.mr-50 {\n  margin-right: 5px;\n}\n\n.mr-100 {\n  margin-right: 5px;\n}\n\n.mr-125 {\n  margin-right: 5px;\n}\n\n.mr-150 {\n  margin-right: 5px;\n}\n\n.mr-175 {\n  margin-right: 5px;\n}\n\n.mr-200 {\n  margin-right: 5px;\n}\n\n/*#endregion*/\n/*Margin Left*/\n/*#region*/\n/*Colors */\n/****BRAND COLORS*****/\n/****END BRAND COLORS*****/\n/* Color Classes*/\n/*#region*/\n.blue.background {\n  background: rgb(22, 109, 255) !important;\n}\n.blue.text {\n  color: rgb(22, 109, 255) !important;\n}\n\n.green.background {\n  background: rgb(124, 187, 46) !important;\n}\n.green.text {\n  color: rgb(124, 187, 46) !important;\n}\n\n.gold.background {\n  background: rgb(255, 189, 28) !important;\n}\n.gold.text {\n  color: rgb(255, 189, 28) !important;\n}\n\n.orange.background {\n  background: rgb(255, 132, 35) !important;\n}\n.orange.text {\n  color: rgb(255, 132, 35) !important;\n}\n\n.red.background {\n  background: rgb(255, 0, 0) !important;\n}\n.red.text {\n  color: rgb(255, 0, 0) !important;\n}\n\n.pink.background {\n  background: rgb(255, 47, 154) !important;\n}\n.pink.text {\n  color: rgb(255, 47, 154) !important;\n}\n\n.purple.background {\n  background: rgb(177, 0, 234) !important;\n}\n.purple.text {\n  color: rgb(177, 0, 234) !important;\n}\n\n.cyan.background {\n  background: rgb(48, 205, 155) !important;\n}\n.cyan.text {\n  color: rgb(48, 205, 155) !important;\n}\n\n/*#endregion*/\n/* Font */\n/* Shadows */\n/* Borders */\n/* Transitions and Animations*/\n/* Z Index */\n.quotes_date_dropdown {\n  width: 200px;\n  background: #fff;\n}\n.quotes_date_dropdown div[class$=-control] {\n  border: none !important;\n  box-shadow: rgba(50, 50, 50, 0.1) 2px 3px 10px;\n  background: none;\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0, 0, 0, 0));\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgba(209, 213, 219, var(--tw-ring-opacity));\n}\n.quotes_date_dropdown div:hover[class$=-control] {\n  --tw-ring-opacity: 1;\n  --tw-ring-color: rgba(96, 165, 250, var(--tw-ring-opacity));\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 rgba(0, 0, 0, 0));\n  transition-duration: 500ms;\n}\n.quotes_date_dropdown div {\n  --tw-text-opacity: 1;\n  color: rgba(55, 65, 81, var(--tw-text-opacity));\n  font-size: 14px;\n}\n.quotes_date_dropdown .css-26l3qy-menu div:not(:hover) {\n  background: none !important;\n}\n.quotes_date_dropdown .css-26l3qy-menu > div > div:hover {\n  background: rgb(225, 235, 255);\n}","@media screen and (max-width: 750px) {\r\n    .main {\r\n        padding: 5px !important;\r\n    }\r\n}","@import \"./variables\";\r\n@import \"./mediaQueries\";\r\n\r\n\r\n/*Wrapper contains the Nav and the Main Content*/\r\n.wrapper {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    overflow: hidden;\r\n    height: 100%;\r\n    min-height: 100vh;\r\n    max-height: 100vh;\r\n    display: flex;\r\n    .page_transition_wrapper {\r\n        width: 100%;\r\n        overflow-x: auto;\r\n        overflow-y: hidden;\r\n        .main {\r\n            position: relative;\r\n            width: 100%;\r\n            max-width: 100%;\r\n            height: 100%;\r\n            max-height: 100%;\r\n            padding: 10px;\r\n            background: rgb(250,250,250);\r\n        }\r\n    }\r\n}\r\n\r\n/*Layout*/\r\n.temp_flex {\r\n    padding: 15px;\r\n    height: 100%;\r\n    max-height: 100%;\r\n    overflow: hidden;\r\n    display: flex;\r\n    background: #fff;\r\n    box-shadow: $side_nav_shadow;\r\n    & > div {\r\n        &:nth-child(1) {\r\n            height: 100%;\r\n            max-height: 100%;\r\n            max-width: 300px;\r\n        }\r\n        &:nth-child(2) {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n.flex {\r\n    display: flex;\r\n    &.justify_content_center {\r\n        justify-content: center;\r\n    }\r\n    &.justify_content_space_between {\r\n        justify-content: space-between;\r\n    }\r\n    &.align_items_center {\r\n        align-items: center;\r\n    }\r\n}\r\n.flex_column {\r\n    display: flex;\r\n    height: 100%;\r\n    flex-direction: column;\r\n    max-height: 100%;\r\n\r\n    .row_1 {\r\n        flex: 1;\r\n    }\r\n    .row_2 {\r\n        flex: 1;\r\n    }\r\n    .row_3 {\r\n        flex: 1;\r\n    }\r\n}\r\n.flex_row {\r\n    display: flex;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    height: 100%;\r\n    max-height: 100%;\r\n    .col_1 {\r\n        flex: 1;\r\n    }\r\n    .col_2 {\r\n        flex: 2;\r\n    }\r\n    .col_3 {\r\n        flex: 3;\r\n    }\r\n}\r\n.padding {\r\n    padding: 20px;\r\n    &.padding_10 {\r\n        padding: 10px;\r\n    }\r\n}\r\n.page {\r\n    height: 100%;\r\n    overflow: hidden;\r\n    max-height: 100%;\r\n    max-width: 100%;\r\n    position: relative;\r\n}\r\n.scrollX {\r\n    overflow-x: scroll;\r\n    width: 200vh !important;\r\n    max-width: none;\r\n}\r\n.stretch_width {\r\n    min-width: 100%;\r\n}\r\n.margin_center {\r\n    margin: 0 auto;\r\n}\r\n.absolute_center {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n.max-w-100 {\r\n    max-width: 100px;\r\n}\r\n\r\n/*Top Bar*/\r\n.top_bar {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 10px;\r\n\r\n    & > div {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n    .left {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n    .right {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n}\r\n\r\n/*Rows */\r\n.rows_wrapper {\r\n    height: 100%;\r\n    max-height: 100%;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n}\r\n.row {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    background: $background_color_primary;\r\n    margin: 6px 0px 6px 0px;\r\n    border-radius: $border-radius;\r\n    box-shadow: $row_shadow;\r\n    padding: 15px;\r\n    transition: all $transition_speed;\r\n    color: $text_color_dark_soft;\r\n\r\n    &:not(.header):hover {\r\n        box-shadow: $row_shadow_hover;\r\n        color: $text_color_dark;\r\n        z-index: 2;\r\n    }\r\n\r\n    &.default {\r\n        cursor: default;\r\n    }\r\n\r\n    //Normal Row\r\n    &.item {\r\n        & > div {\r\n            flex: 1;\r\n            font-size: $font_size_standard;\r\n        }\r\n    }\r\n\r\n    //Header Row\r\n    &.header {\r\n        cursor: default;\r\n        width: 100%;\r\n        margin-bottom: 0px;\r\n        height: 50px;\r\n        & > div {\r\n            flex: 1;\r\n            text-transform: uppercase;\r\n            color: $text_color_dark_soft;\r\n            transition: all $transition_speed;\r\n            cursor: pointer;\r\n\r\n            svg {\r\n                //For sort icon\r\n                margin-left: 10px;\r\n            }\r\n\r\n            &:hover {\r\n                color: $text_color_dark;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/* Text */\r\n.text_align_left {\r\n    text-align: left !important;\r\n}\r\n.text_align_right {\r\n    text-align: right !important;\r\n}\r\n.text_align_center {\r\n    text-align: center !important;\r\n}\r\n\r\n/*Headers*/\r\n.title {\r\n    margin: 0px;\r\n    max-width: 400px;\r\n    text-align: center;\r\n    transition: all $transition_speed;\r\n    color: $text_color_dark_soft;\r\n    text-transform: uppercase;\r\n    font-size: 30px;\r\n    cursor: default;\r\n\r\n    &.form_title {\r\n        margin: 20px auto;\r\n        width: 100%;\r\n        text-align: center;\r\n    }\r\n}\r\n\r\n/*Buttons and Links*/\r\n.button_wrapper {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    width: 100%;\r\n}\r\n.button {\r\n    position: relative;\r\n    display: block;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    padding: 8px 20px;\r\n    white-space: nowrap;\r\n    border-radius: $border_button_radius;\r\n    cursor: pointer;\r\n    margin: 10px;\r\n    transition: all $transition_speed;\r\n    font-size: $font_size_button;\r\n    outline: none;\r\n\r\n    &:active {\r\n        outline: none;\r\n    }\r\n\r\n    &.primary {\r\n        background: $color_primary;\r\n        color: $text_color_light;\r\n    }\r\n    &.delete {\r\n        background: $color_error;\r\n        color: $text_color_light;\r\n    }\r\n    &.outline {\r\n        background: $text_color_light;\r\n        border: 1px solid $color_primary;\r\n        color: $color_primary;\r\n\r\n        &:hover {\r\n            color: $text_color_light;\r\n            background: $color_primary;\r\n        }\r\n    }\r\n    &.checkout {\r\n        background: $text_color_light;\r\n        border: 1px solid $orange;\r\n        color: $orange;\r\n\r\n        &:hover {\r\n            color: $text_color_light;\r\n            background: $orange;\r\n        }\r\n    }\r\n    &.suspend {\r\n        background: $gold;\r\n        color: $text_color_light;\r\n    }\r\n    &.unsuspend {\r\n        background: $green;\r\n        color: $text_color_light;\r\n    }\r\n    &.upload {\r\n        background: $gold;\r\n        color: $text_color_light;\r\n        width: 180px;\r\n    }\r\n    &.cancel {\r\n    }\r\n    &.secondary {\r\n        color: $text_color_dark_soft;\r\n    }\r\n    &.slide_next {\r\n        position: absolute;\r\n        bottom: 20px;\r\n        right: 20px;\r\n\r\n        &.left {\r\n            right: 130px;\r\n        }\r\n        &.right {\r\n        }\r\n    }\r\n    &.slide_previous {\r\n        position: absolute;\r\n        bottom: 20px;\r\n        left: 20px;\r\n    }\r\n    &.back {\r\n        background: $gold;\r\n        color: $text_color_light;\r\n        &:hover {\r\n            svg {\r\n                transition: all $transition_speed;\r\n                transform: translateX(-5px);\r\n            }\r\n        }\r\n    }\r\n    &.next {\r\n        svg {\r\n            margin-left: 5px;\r\n        }\r\n        &:hover {\r\n            svg {\r\n                transition: all $transition_speed;\r\n                transform: translateX(5px);\r\n            }\r\n        }\r\n    }\r\n    &.form_button {\r\n        //the reason this isn't inside the form is so the form can scroll, but the button is stationary under the form\r\n        margin: 30px 10px;\r\n    }\r\n    &.row_button {\r\n        background: $cyan;\r\n        color: $text_color_light;\r\n    }\r\n    &.center {\r\n        margin: 0 auto;\r\n        width: 100%;\r\n        max-width: 250px;\r\n    }\r\n    &.disabled {\r\n        cursor: not-allowed;\r\n        opacity: 0.5;\r\n        &:hover {\r\n            filter: brightness(1);\r\n        }\r\n    }\r\n    svg {\r\n        //icons in buttons\r\n        margin-right: 5px;\r\n    }\r\n}\r\na {\r\n    font-size: $font_size_standard;\r\n    &.link {\r\n        color: $blue;\r\n        &:hover {\r\n            text-decoration: underline !important;\r\n        }\r\n    }\r\n}\r\n\r\n/*Forms*/\r\nform {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    overflow-y: auto;\r\n    padding: 20px 40px;\r\n    min-width: 500px;\r\n\r\n    .form_outline_error:not(.form_checkbox_wrapper) {\r\n        border: 2px solid $red !important;\r\n    }\r\n\r\n    .form_input_error {\r\n        display: inline-block;\r\n        margin-left: 5px;\r\n        color: $red;\r\n        font-size: $font_size_small;\r\n    }\r\n\r\n    .form_group {\r\n        display: flex;\r\n        margin: 10px 0px;\r\n        cursor: pointer;\r\n        width: 100%;\r\n        max-width: 100%;\r\n\r\n        & > div {\r\n            flex: 1;\r\n            display: flex;\r\n            flex-direction: column;\r\n            color: $text_color_dark_soft;\r\n\r\n            &:not(:nth-child(1)) {\r\n                margin-left: 10px;\r\n            }\r\n        }\r\n\r\n        .form_checkbox_wrapper {\r\n            display: flex;\r\n            justify-content: flex-start;\r\n            flex-direction: column;\r\n\r\n            & > label {\r\n                margin: 15px 0 10px 0;\r\n                font-weight: 800;\r\n            }\r\n\r\n            .form_input_error {\r\n                font-weight: 500 !important;\r\n            }\r\n\r\n            &.form_outline_error .form_checkbox {\r\n                label {\r\n                    color: $red;\r\n                }\r\n            }\r\n\r\n            .form_checkbox_container {\r\n                display: flex;\r\n                justify-content: flex-start;\r\n                cursor: default;\r\n                .form_checkbox {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    cursor: pointer;\r\n\r\n                    &:not(:nth-child(1)) {\r\n                        margin-left: 20px;\r\n                    }\r\n\r\n                    input {\r\n                        border: none;\r\n                        cursor: pointer;\r\n                    }\r\n                    label {\r\n                        cursor: pointer;\r\n                        margin-bottom: 0px;\r\n                        padding-right: 5px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        label {\r\n            color: $text_color_dark_soft;\r\n            margin-bottom: 5px;\r\n            font-size: $font_size_standard;\r\n\r\n            &.disabled {\r\n                opacity: 0.5;\r\n            }\r\n        }\r\n\r\n        input[type=\"radio\"] {\r\n            border: 1px solid $border_color_primary !important;\r\n            min-width: $font_size_standard;\r\n            min-height: $font_size_standard;\r\n        }\r\n\r\n        input:not([type=\"checkbox\"]),\r\n        select,\r\n        textarea,\r\n        .multi-select > .dropdown-container {\r\n            width: 100%;\r\n            border-radius: 5px;\r\n            border: 2px solid transparent;\r\n            padding: 10px;\r\n            box-shadow: $form_input_shadow;\r\n            outline: none;\r\n            transition: all $transition_speed;\r\n            color: $text_color_dark_soft;\r\n\r\n            &:focus {\r\n                border: 2px solid $text_color_dark_soft;\r\n\r\n                &::placeholder {\r\n                    color: $placeholder_color_hover;\r\n                }\r\n            }\r\n            &::placeholder {\r\n                color: $placeholder_color;\r\n                transition: all $transition_speed;\r\n            }\r\n            &:hover {\r\n                box-shadow: $form_input_shadow_hover;\r\n                &::placeholder {\r\n                    color: $placeholder_color_hover;\r\n                }\r\n            }\r\n            &.disabled {\r\n                opacity: 0.5;\r\n                &:hover {\r\n                    box-shadow: $form_input_shadow;\r\n                    border: 2px solid transparent;\r\n                    cursor: not-allowed;\r\n                }\r\n                &:focus {\r\n                    box-shadow: $form_input_shadow;\r\n                    border: 2px solid transparent;\r\n                }\r\n                &::placeholder {\r\n                    color: $text_color_light_soft;\r\n                }\r\n            }\r\n        }\r\n\r\n        .multi-select > .dropdown-container {\r\n            padding: 0px;\r\n        }\r\n\r\n        /*HIDE ARROWS ON NUMBER INPUTS*\r\n            /* Chrome, Safari, Edge, Opera */\r\n        input::-webkit-outer-spin-button,\r\n        input::-webkit-inner-spin-button {\r\n            -webkit-appearance: none;\r\n            margin: 0;\r\n        }\r\n        /* Firefox */\r\n        input[type=\"number\"] {\r\n            -moz-appearance: textfield;\r\n        }\r\n    }\r\n}\r\n.qty_wrapper {\r\n    .qty {\r\n        width: 45px;\r\n        padding: 5px;\r\n        border: none;\r\n        border: 1px solid $border_color_primary;\r\n        font-size: 16px;\r\n    }\r\n}\r\n\r\n/* Loader*/\r\n.loader_fullscreen {\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    right: 0;\r\n    left: 0;\r\n    background: rgba(20, 20, 20, 0.05);\r\n    z-index: $z_loader;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n/* Leaflet */\r\n.leaflet-draw.leaflet-control {\r\n    & {\r\n        display: none;\r\n    }\r\n    &:nth-child(2) {\r\n        display: block !important;\r\n    }\r\n}\r\n.leaflet-control-layers-overlays {\r\n    & > label:first-child {\r\n        display: none;\r\n    }\r\n}\r\n\r\n/* Search Bar */\r\n.search_bar {\r\n    margin: 0 auto;\r\n    margin-right: 10px;\r\n    max-width: 100%;\r\n    &.margin_left {\r\n        margin-left: 25px;\r\n    }\r\n    input {\r\n        width: 100%;\r\n        border: 2px solid $color_gray;\r\n        border-radius: $border-radius;\r\n        padding: 5px;\r\n        box-shadow: $form_input_shadow;\r\n        outline: none;\r\n        transition: all $transition_speed;\r\n        color: $text_color_dark_soft;\r\n\r\n        &:focus {\r\n            border: 2px solid $text_color_dark_soft;\r\n            &::placeholder {\r\n                color: $placeholder_color_hover;\r\n            }\r\n        }\r\n        &::placeholder {\r\n            color: $placeholder_color;\r\n            transition: all $transition_speed;\r\n        }\r\n        &:hover {\r\n            box-shadow: $form_input_shadow_hover;\r\n            &::placeholder {\r\n                color: $placeholder_color_hover;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n/* CSS SPECIFIC STYLING */\r\n\r\n/*Margin*/\r\n/*#region*/\r\n\r\n/*Margin Right*/\r\n/*#region*/\r\n.mr-5 {\r\n    margin-right: 5px;\r\n}\r\n.mr-10 {\r\n    margin-right: 5px;\r\n}\r\n.mr-15 {\r\n    margin-right: 5px;\r\n}\r\n.mr-25 {\r\n    margin-right: 5px;\r\n}\r\n.mr-50 {\r\n    margin-right: 5px;\r\n}\r\n.mr-100 {\r\n    margin-right: 5px;\r\n}\r\n.mr-125 {\r\n    margin-right: 5px;\r\n}\r\n.mr-150 {\r\n    margin-right: 5px;\r\n}\r\n.mr-175 {\r\n    margin-right: 5px;\r\n}\r\n.mr-200 {\r\n    margin-right: 5px;\r\n}\r\n/*#endregion*/\r\n\r\n/*Margin Left*/\r\n/*#region*/","@import \"../../../styles/variables\";\r\n\r\n.quotes_date_dropdown {\r\n    width: 200px;\r\n    background: #fff;\r\n\r\n    div[class$=\"-control\"] {\r\n        border: none !important;\r\n        box-shadow: $row_shadow;\r\n        background: none;\r\n\r\n        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n\r\n        --tw-ring-opacity: 1;\r\n        --tw-ring-color: rgba(209, 213, 219, var(--tw-ring-opacity));\r\n    }\r\n\r\n    div:hover[class$=\"-control\"] {\r\n        --tw-ring-opacity: 1;\r\n        --tw-ring-color: rgba(96, 165, 250, var(--tw-ring-opacity));\r\n        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n        transition-duration: 500ms;\r\n    }\r\n\r\n    div {\r\n        --tw-text-opacity: 1;\r\n        color: rgba(55, 65, 81, var(--tw-text-opacity));\r\n        font-size: 14px;\r\n    }\r\n\r\n    .css-26l3qy-menu div:not(:hover) {\r\n        background: none !important;\r\n    }\r\n\r\n    .css-26l3qy-menu > div > div:hover {\r\n        background: rgb(225, 235, 255);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
